// extracted by mini-css-extract-plugin
export var fadein = "index-module--fadein--xFx8j";
export var wrapper = "index-module--wrapper--9xZCv";